import { usePosStore } from '../store/posStore';
import type { EmitirOrdenRequest } from '../types/pos.types';

export const usePosOrder = () => {
  const {
    ordenActual,
    ordenes,
    ordenLoading,
    ordenSaving,
    emitirOrden,
    cancelarOrden,
    fetchOrdenes,
    seleccionarOrden,
    setPaymentDialogOpen,
    paymentDialogOpen,
    error,
  } = usePosStore();

  const handleEmitir = async (data: EmitirOrdenRequest) => {
    return await emitirOrden(data);
  };

  const handleCancelar = async () => {
    await cancelarOrden();
  };

  const openPayment = () => {
    if (ordenActual && ordenActual.detalles.length > 0) {
      setPaymentDialogOpen(true);
    }
  };

  return {
    ordenActual,
    ordenes,
    loading: ordenLoading,
    saving: ordenSaving,
    paymentDialogOpen,
    error,
    handleEmitir,
    handleCancelar,
    fetchOrdenes,
    seleccionarOrden,
    openPayment,
    closePayment: () => setPaymentDialogOpen(false),
  };
};
